import request from '@/utils/request'

// 查询毕业生生源信息列表
export function listByssy(query) {
  return request({
    url: '/web/xwqy/byssy/list',
    method: 'get',
    params: query
  })
}
